export default "__VITE_ASSET__CnkU5F5c__"